module.exports = __webpack_public_path__ + "static/media/silver-member-mobile.f29ae406.svg";